import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import './App.css';
import { Layout } from "./layouts/Layout";
import { SignUp } from "./pages/SignUp";
import { CompleteRegistration } from "./pages/CompleteRegistration";
import { Login } from "./pages/Login";
import { ForgotPassword } from "./pages/ForgotPassword";
import { EnterOtp } from "./pages/EnterOtp";
import { AdminLayout } from "./layouts/AdminLayout";
import { AuthLayout } from "./layouts/AuthLayout";
import { LinkAccounts } from "./pages/LinkAccounts";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfServices } from "./pages/TermsOfServices";
// Import toast container
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Admin section pages
import { Dashboard } from "./pages/admin/Dashboard";
import { DataAnalyst } from "./pages/admin/DataAnalyst/DataAnalyst";
import { GrowthEngine } from "./pages/admin/GrowthEngine/GrowthEngine";
import Stepper from "./pages/admin/GrowthEngine/Stepper";
import { FeatureFM } from "./pages/admin/GrowthEngine/FeatureFM";
import { YoutubeVideos } from "./pages/admin/GrowthEngine/YoutubeVideos";
import { YoutubeTarget } from "./pages/admin/GrowthEngine/YoutubeTarget";
import { CampaignHistory } from "./pages/admin/GrowthEngine/CampaignHistory";
import { CampaignEditor } from "./pages/admin/GrowthEngine/CampaignEditor";
import CampaignEditorDemo from "./pages/admin/GrowthEngine/CampaignEditorDemo";
import { DuplicateCampaignDetails } from "./pages/admin/GrowthEngine/DuplicateCampaignDetails";
import AmplitudeAI from "./pages/admin/AmplitudeAI";
import Catalog from "./pages/admin/DataAnalyst/Catalog";
import Milestones from "./pages/admin/DataAnalyst/Milestones";
import RadioPlay from "./pages/admin/DataAnalyst/RadioPlay";
import Homepage from "./pages/Homepage";
import Pricing from "./pages/Pricing";
import FeaturesPage from "./pages/Features";
import OurStoryPage from "./pages/OurStory";
import TutorialsPage from "./pages/Tutorials";
import CaseStudiesPage from "./pages/CaseStudies";
import BlogPage from "./pages/Blog";
import HelpCenterPage from "./pages/HelpCenter";
import CommunityUpdatesPage from "./pages/CommunityUpdates";
import CookiePolicyPage from "./pages/CookiePolicy";
import { ArtistManager } from "./pages/admin/ArtistManager/ArtistManager";
import { Teams } from "./pages/admin/Teams/Teams";
import { ReleaseAndFinancialPlanner } from "./pages/admin/ArtistManager/ReleaseAndFinancialPlanner";
import { LinkAndFanHub } from "./pages/admin/LinkAndFanHub/LinkAndFanHub";
import FanEngagement from "./pages/admin/LinkAndFanHub/FanEngagement/FanEngagement";
import BioLink from "./pages/admin/LinkAndFanHub/BuildBioLink/BioLink";
import MusicLink from "./pages/admin/LinkAndFanHub/BuildMusicLink/MusicLink";
import TourLink from "./pages/admin/LinkAndFanHub/BuildTourLink/TourLink";
import PreSaveLink from "./pages/admin/LinkAndFanHub/PreSave/PreSaveLink";
import { NavigationProvider } from "./context/NavigationContext";
// import { AppTourProvider, AppTour } from "./components/AppTour";
import UrStudio from "./pages/admin/UrStudio/UrStudio";
import AudioEngineer from "./pages/admin/UrStudio/AudioEngineer/AudioEngineer";
import AudioEngineerDemo from "./pages/admin/UrStudio/AudioEngineer/AudioEngineerDemo";
import MixingEngineer from "./pages/admin/UrStudio/MixingEngineer/MixingEngineer";
import MixAnalyst from "./pages/admin/UrStudio/MixAnalyst/MixAnalyst";
import { AnalysisReport } from "./pages/admin/UrStudio/MixAnalyst/AnalysisReport";
import MixEnhancer from "./pages/admin/UrStudio/MixEnhancer/MixEnhancer";
import { useClearToastsOnMount } from "./hooks/useClearToastsOnMount";
import ProfessorU from "./pages/admin/ProfessorU/ProfessorU";
import Distribution from "./pages/Distribution";
import LessonsPage from "./pages/admin/ProfessorU/LessonsPage";
import ResourceLibrary from "./pages/admin/ProfessorU/ResourceLibrary";
import Rewards from "./pages/admin/ProfessorU/Rewards";
import ContentViewer from "./pages/admin/ProfessorU/components/ContentViewer";
import PreSaveLinkDemo from "./pages/admin/LinkAndFanHub/PreSave/PreSaveLinkDemo";
import MixingEngineerDemo from "./pages/admin/UrStudio/MixingEngineer/MixingEngineerDemo";
import LinkAnalyticsDemoPage from "./pages/admin/LinkAnalyticsDemoPage";
import StepperDemo from "./pages/admin/GrowthEngine/StepperDemo";
import ArticlePage from "./pages/ArticlePage";
import { LinksFanHubRouteGuard } from "./components/LinksFanHubRouteGuard";
import AccountSetup from "./pages/Distribution Demo/AccountSetup";
import MusicRelease from "./pages/Distribution Demo/MusicRelease";
import InterviewAndGuideViewer from "./pages/admin/ProfessorU/components/InterviewAndGuideViewer";

// Private Route Component
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("authToken"); // Check for token in local storage
  return token ? children : <Navigate to="/login" replace />;
};
const WrappedPreSave = () => (
  <PrivateRoute>
    <LinksFanHubRouteGuard>
      <AdminLayout>
        <PreSaveLink />
      </AdminLayout>
    </LinksFanHubRouteGuard>
  </PrivateRoute>
);
const WrappedBioLink = () => (
  <PrivateRoute>
    <LinksFanHubRouteGuard>
      <AdminLayout>
        <BioLink />
      </AdminLayout>
    </LinksFanHubRouteGuard>
  </PrivateRoute>
);
const WrappedTourLink = () => (
  <PrivateRoute>
    <LinksFanHubRouteGuard>
      <AdminLayout>
        <TourLink />
      </AdminLayout>
    </LinksFanHubRouteGuard>
  </PrivateRoute>
);
const WrappedMusicLink = () => (
  <PrivateRoute>
    <LinksFanHubRouteGuard>
      <AdminLayout>
        <MusicLink />
      </AdminLayout>
    </LinksFanHubRouteGuard>
  </PrivateRoute>
);
const WrappedFanEngagement = () => (
  <PrivateRoute>
    <LinksFanHubRouteGuard>
      <AdminLayout>
        <FanEngagement />
      </AdminLayout>
    </LinksFanHubRouteGuard>
  </PrivateRoute>
);
const WrappedPreSaveDemo = () => (
  <PrivateRoute>
    <AdminLayout>
      <PreSaveLinkDemo />
    </AdminLayout>
  </PrivateRoute>
);

const AppInner = () => {
  useClearToastsOnMount();  // ← now inside Router context
  return null;
};

function RootLayout() {
  return (
    <>
      {/*ToastContainer should be rendered ONCE globally */}
      <AppInner />
      <ToastContainer position="top-center" theme="colored" hideProgressBar />
      <Outlet />
      {/* <AppTour /> */}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <NavigationProvider>
        <Routes>
          <Route element={<RootLayout />}>
            <Route path="signup" element={<AuthLayout><SignUp /></AuthLayout>} />
            <Route path="verify-otp" element={<AuthLayout><EnterOtp /></AuthLayout>} />
            <Route path="complete-registration" element={<AuthLayout><CompleteRegistration /></AuthLayout>} />
            <Route path="login" element={<AuthLayout><Login /></AuthLayout>} />
            <Route path="forgot-password" element={<AuthLayout><ForgotPassword /></AuthLayout>} />
            <Route path="link-accounts" element={<AuthLayout><LinkAccounts /></AuthLayout>} />

            {/* Public site routes */}
            <Route index element={<Layout><Homepage /></Layout>} />
            <Route path="pricing" element={<Layout><Pricing /></Layout>} />
            <Route path="features" element={<Layout><FeaturesPage /></Layout>} />
            <Route path="features/:id" element={<Layout><FeaturesPage /></Layout>} />
            <Route path="our-story" element={<Layout><OurStoryPage /></Layout>} />
            <Route path="tutorials" element={<Layout><TutorialsPage /></Layout>} />
            <Route path="case-studies" element={<Layout><CaseStudiesPage /></Layout>} />
            <Route path="blog" element={<Layout><BlogPage /></Layout>} />
            <Route path="blog/:slug" element={<Layout><ArticlePage /></Layout>} />
            <Route path="help-center" element={<Layout><HelpCenterPage /></Layout>} />
            <Route path="community-updates" element={<Layout><CommunityUpdatesPage /></Layout>} />
            <Route path="privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
            <Route path="terms-of-service" element={<Layout><TermsOfServices /></Layout>} />
            <Route path="cookie-policy" element={<Layout><CookiePolicyPage /></Layout>} />
            <Route path="distribution" element={<Layout><Distribution /></Layout>} />

            {/* Protected Admin Routes */}
            <Route path="dashboard" element={<PrivateRoute><AdminLayout><Dashboard /></AdminLayout></PrivateRoute>} />
            <Route path="admin/data-analyst" element={<PrivateRoute><AdminLayout><DataAnalyst /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine" element={<PrivateRoute><AdminLayout><GrowthEngine /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/campaign" element={<PrivateRoute><AdminLayout><Stepper /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/campaign-demo" element={<PrivateRoute><AdminLayout><StepperDemo /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/campaign-editor-demo" element={<PrivateRoute><AdminLayout><CampaignEditorDemo /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/feature-fm" element={<PrivateRoute><AdminLayout><FeatureFM /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/choose-youtube-video" element={<PrivateRoute><AdminLayout><YoutubeVideos /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/choose-youtube-target" element={<PrivateRoute><AdminLayout><YoutubeTarget /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/campaign-history" element={<PrivateRoute><AdminLayout><CampaignHistory /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/campaign-editor/:campaignId" element={<PrivateRoute><AdminLayout><CampaignEditor /></AdminLayout></PrivateRoute>} />
            <Route path="admin/growth-engine/duplicate-campaign" element={<PrivateRoute><AdminLayout><DuplicateCampaignDetails /></AdminLayout></PrivateRoute>} />
            <Route path="admin/amplitude-ai" element={<PrivateRoute><AdminLayout><AmplitudeAI /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio" element={<PrivateRoute><AdminLayout><UrStudio /></AdminLayout></PrivateRoute>} />
            <Route path="admin/audio-engineer" element={<PrivateRoute><AdminLayout><AudioEngineer /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio/audio-engineer-demo" element={<PrivateRoute><AdminLayout><AudioEngineerDemo /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio/audio-engineer" element={<PrivateRoute><AdminLayout><AudioEngineer /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio/mixing-engineer-demo" element={<PrivateRoute><AdminLayout><MixingEngineerDemo /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio/mixing-engineer" element={<PrivateRoute><AdminLayout><MixingEngineer /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio/mix-analyst" element={<PrivateRoute><AdminLayout><MixAnalyst /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio/mix-enhancer" element={<PrivateRoute><AdminLayout><MixEnhancer /></AdminLayout></PrivateRoute>} />
            <Route path="admin/urstudio/analysis-report" element={<PrivateRoute><AdminLayout><AnalysisReport /></AdminLayout></PrivateRoute>} />
            <Route path="admin/data-analyst/catalog" element={<PrivateRoute><AdminLayout><Catalog /></AdminLayout></PrivateRoute>} />
            <Route path="admin/data-analyst/milestones" element={<PrivateRoute><AdminLayout><Milestones /></AdminLayout></PrivateRoute>} />
            <Route path="admin/data-analyst/radioplay" element={<PrivateRoute><AdminLayout><RadioPlay /></AdminLayout></PrivateRoute>} />
            <Route path="admin/artist-manager" element={<PrivateRoute><AdminLayout><ArtistManager /></AdminLayout></PrivateRoute>} />
            <Route path="admin/teams" element={<PrivateRoute><AdminLayout><Teams /></AdminLayout></PrivateRoute>} />
            <Route path="admin/artist-manager/release-and-financial-planner" element={<PrivateRoute><AdminLayout><ReleaseAndFinancialPlanner /></AdminLayout></PrivateRoute>} />
            <Route path="admin/artist-manager/link-and-fan-hub" element={<PrivateRoute><AdminLayout><LinkAndFanHub /></AdminLayout></PrivateRoute>} />
            <Route path="admin/artist-manager/fan-engage" element={<WrappedFanEngagement />} />
            <Route path="admin/artist-manager/build-bio-link" element={<WrappedBioLink />} />
            <Route path="admin/artist-manager/edit-bio-link/:id" element={<WrappedBioLink />} />
            <Route path="admin/artist-manager/build-tour-link" element={<WrappedTourLink />} />
            <Route path="admin/artist-manager/edit-tour-link/:id" element={<WrappedTourLink />} />
            <Route path="admin/artist-manager/build-music-link" element={<WrappedMusicLink />} />
            <Route path="admin/artist-manager/edit-music-link/:smartLinkId" element={<WrappedMusicLink />} />
            <Route path="admin/artist-manager/pre-save-analytics" element={<WrappedPreSave />} />
            <Route path="admin/artist-manager/link-analytics-demo" element={<PrivateRoute><AdminLayout><LinkAnalyticsDemoPage /></AdminLayout></PrivateRoute>} />
            <Route path="admin/artist-manager/create-pre-save" element={<WrappedPreSave />} />
            <Route path="admin/artist-manager/create-pre-save-demo" element={<WrappedPreSaveDemo />} />
            <Route path="admin/artist-manager/edit-pre-save/:id" element={<WrappedPreSave />} />
            <Route path="admin/professor-u" element={<PrivateRoute><AdminLayout><ProfessorU /></AdminLayout></PrivateRoute>} />
            <Route path="admin/professor-u/lessons" element={<PrivateRoute><AdminLayout><LessonsPage /></AdminLayout></PrivateRoute>} />
            <Route path="admin/professor-u/resource-library" element={<PrivateRoute><AdminLayout><ResourceLibrary /></AdminLayout></PrivateRoute>} />
            <Route path="admin/professor-u/rewards" element={<PrivateRoute><AdminLayout><Rewards /></AdminLayout></PrivateRoute>} />
            <Route path="admin/professor-u/contents" element={<PrivateRoute><AdminLayout><ContentViewer /></AdminLayout></PrivateRoute>} />
            <Route path="admin/professor-u/guides" element={<PrivateRoute><AdminLayout><InterviewAndGuideViewer /></AdminLayout></PrivateRoute>} />
            <Route path="distribution/account-setup-demo" element={<AdminLayout><AccountSetup /></AdminLayout>} />
            <Route path="distribution/music-release-demo" element={<AdminLayout><MusicRelease /></AdminLayout>} />
          </Route>
        </Routes>
      </NavigationProvider>
    </BrowserRouter>
  );
}

export default App;
